import { render, staticRenderFns } from "./AddMemberByDeptModal.vue?vue&type=template&id=0bcb34c8&scoped=true&"
import script from "./AddMemberByDeptModal.vue?vue&type=script&lang=js&"
export * from "./AddMemberByDeptModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberByDeptModal.vue?vue&type=style&index=0&id=0bcb34c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb34c8",
  null
  
)

export default component.exports